import React, { ReactElement } from 'react'
import { Box, Link, Text } from '@mindfulchefuk/design-system'
import NextLink from 'next/link'

export const RecipeDetailsInfo = ({
  info,
}: {
  info: {
    name: string
    value: string
    href?: string
  }[]
}): ReactElement => (
  <Box>
    {info.map(({ name, value, href }) => {
      if (!value || value.length === 0) return null

      return (
        <Box key={name}>
          <Text
            variant="body-md-500"
            as="span"
            data-testid="recipe-details-info-name"
          >
            {name}:{' '}
          </Text>
          {href ? (
            <NextLink href={href} passHref>
              <Link data-testid="recipe-details-info-value">{value}</Link>
            </NextLink>
          ) : (
            <Text
              variant="body-md"
              as="span"
              data-testid="recipe-details-info-value"
            >
              {value}
            </Text>
          )}
        </Box>
      )
    })}
  </Box>
)
